export const STORAGE_KEYS = {
  DONATION_RETURN_URL: 'donation_return_url',
  DONOR_RETURN_URL: 'donor_return_url',
  USER_INFO: 'user',
  MOCK_DATA_VERSION: 'mockDataVersion'
} as const;
